import type { ReactCodeMirrorRef } from "@uiw/react-codemirror";
import { type RefObject, useEffect, useRef } from "react";
import { usePipelineStaging } from "./pipelineStaging";

// Hands the caret to this editor when the Studio asks for it (an AI
// Helper Insert that just landed, TTTL-217). Every editor stays mounted
// and listens; a hidden one's CodeMirror can't take focus, so only the
// editor on screen actually does. Requests from before this editor
// mounted are not its to answer — the Full pipeline editor mounting on a
// view switch must not grab a caret meant for an earlier insert.
export function useEditorFocusRequest(
  cmRef: RefObject<ReactCodeMirrorRef | null>,
) {
  const { editorFocusRequest } = usePipelineStaging();
  const answered = useRef(editorFocusRequest?.token ?? 0);
  useEffect(() => {
    const token = editorFocusRequest?.token ?? 0;
    if (token <= answered.current) return;
    answered.current = token;
    cmRef.current?.view?.focus();
  }, [editorFocusRequest, cmRef]);
}
